'use strict';

var isCallable = require('../internals/is-callable');

var isObject = require('../internals/is-object');

var definePropertyModule = require('../internals/object-define-property');

var getPrototypeOf = require('../internals/object-get-prototype-of');

var wellKnownSymbol = require('../internals/well-known-symbol');

var makeBuiltIn = require('../internals/make-built-in');

var HAS_INSTANCE = wellKnownSymbol('hasInstance');
var FunctionPrototype = Function.prototype; // `Function.prototype[@@hasInstance]` method
// https://tc39.es/ecma262/#sec-function.prototype-@@hasinstance

if (!(HAS_INSTANCE in FunctionPrototype)) {
  definePropertyModule.f(FunctionPrototype, HAS_INSTANCE, {
    value: makeBuiltIn(function (O) {
      if (!isCallable(this) || !isObject(O)) return false;
      var P = this.prototype;
      if (!isObject(P)) return O instanceof this; // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:

      while (O = getPrototypeOf(O)) {
        if (P === O) return true;
      }

      return false;
    }, HAS_INSTANCE)
  });
}